<div></div>
<div class="p-7 bg-lightest">
  <div class="md:inline">
    <div class="back md:ml-10 md:inline">
      <button
        pButton
        class="back-accueil font-app-medium"
        (click)="resetView()">
        <i class="pi pi-arrow-left mr-4"></i>
        <span class="inline">{{ "homePage.back" | translate }}</span>
      </button>
    </div>
    <div>
      <h1 class="text-xl lg:flex lg:flex-row lg:text-2xl font-app-bold mb-5 md:mb-10 mt-5 lg:ml-[40px]">
        {{ "receipt.title" | translate }}
      </h1>

      <!-- Bouton de menu pour mobile -->
      <button
        pButton
        class="block ml-auto lg:hidden p-2"
        (click)="toggleMenu()">
        <i
          *ngIf="!isMenuOpen"
          class="pi pi-ellipsis-h"></i>
        <i
          *ngIf="isMenuOpen"
          class="pi pi-ellipsis-v"></i>
      </button>
      <div
        *ngIf="isMenuOpen"
        class="absolute top-full mt-2 bg-white shadow-none border border-light rounded-lg p-2 z-50 w-screen -ml-7">
        <app-service-offerings-mrh
          *ngIf="!isPolicyWaitingForSignature && policyDetails && isMrhBranch"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [hasLegalJr]="policyDetails.legalProtection"
          [isGdaAllowed]="isGdaAllowed"
          [productCode]="policyDetails.formulasAndOptionsInformations.formulaCode" />

        <app-service-offerings-pj
          *ngIf="!isPolicyWaitingForSignature && policyDetails && isPJBranch"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct" />

        <app-service-offerings-sa
          *ngIf="!isPolicyWaitingForSignature && policyDetails && isSaBranch"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct"
          [fSDocument]="fSDocument" />
      </div>
    </div>
  </div>
  <div class="lg:grid lg:grid-cols-3 lg:gap-4">
    <div class="border-light border rounded-md shadow-none bg-white p-2 lg:ml-9 col-span-2 lg:w-[80%]">
      <div class="bg-lightest pb-2 p-4">
        <div class="flex justify-between p-4">
          <app-address-mrh
            *ngIf="isMrhBranch"
            [bgLogo]="'bg-white'"
            [colorLogo]="'text-primary'"
            [data]="addressData"></app-address-mrh>

          <app-title-pj
            *ngIf="isPJBranch"
            [bgLogo]="'bg-primary'"
            [colorLogo]="'text-white'"></app-title-pj>

          <app-title-sa
            *ngIf="isSaBranch"
            [bgLogo]="'bg-primary'"
            [colorLogo]="'text-white'"></app-title-sa>

          <div>
            <button
              pButton
              class="mr-4 inline-flex items-center text-white font-bold text-[10px] rounded-full px-4 py-2 bg-severity-low"
              (click)="generateEcheancierDialogVisibleChange(true)"
              [disabled]="!generationEcheancierIsAvailable()">
              <i class="pi pi-download"></i>
              <span class="ml-2 hidden md:block">{{ "receipt.generateEcheancier" | translate }}</span>
            </button>

            <app-status-card
              *ngIf="policyDetails"
              [status]="policyDetails.status"
              [statusConfig]="policyStatusConfigStatus"
              [date]="policyDetails.effectiveStartDate"
              class="justify-end" />
          </div>
        </div>
        <div class="bg-white">
          <app-detail-info-card-mrh
            *ngIf="isMrhBranch"
            [validityDate]="policyDetails.paymentDate"
            [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
            [promotionCode]="policyDetails.promotionCode"
            [effectiveStartDate]="policyDetails.effectiveStartDate"
            [untilTextKey]="'contractDetails.nextPayment'"
            [amountTextKey]="'contractDetails.debitAmount'"
            [promoTextKey]="'contractDetails.promoCode'"></app-detail-info-card-mrh>

          <app-detail-info-card-pj
            *ngIf="isPJBranch"
            [validityDate]="policyDetails.paymentDate"
            [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
            [promotionCode]="policyDetails.promotionCode"
            [effectiveStartDate]="policyDetails.effectiveStartDate"
            [terminationDate]="policyDetails.terminationDate"
            [untilTextKey]="'contractDetails.nextPayment'"
            [amountTextKey]="'contractDetails.debitAmount'"
            [promoTextKey]="'contractDetails.promoCode'"
            [policyStatus]="policyDetails.status"></app-detail-info-card-pj>

          <app-detail-info-card-sa
            *ngIf="isSaBranch"
            [validityDate]="policyDetails.paymentDate"
            [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
            [promotionCode]="policyDetails.promotionCode"
            [effectiveStartDate]="policyDetails.effectiveStartDate"
            [terminationDate]="policyDetails.terminationDate"
            [untilTextKey]="'contractDetails.nextPayment'"
            [amountTextKey]="'contractDetails.debitAmount'"
            [promoTextKey]="'contractDetails.promoCode'"
            [policyStatus]="policyDetails.status"></app-detail-info-card-sa>

          <div class="font-app-bold w-[97%] mx-auto mb-3">
            <app-receipts-detail-info
              [policyId]="policyId"
              [paymentSchedule]="paymentSchedule"
              [needPayment]="needPayment" />
            <hr class="border-t-2 border-lightest w-full my-2" />
            <div class="px-2 py-4">
              <app-payment-informations
                *ngIf="policyDetails?.bankInformationPolicyVm"
                [paymentInformations]="policyDetails.bankInformationPolicyVm"></app-payment-informations>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="fixed hidden lg:flex flex-col space-y-4 ml-4">
        <app-service-offerings-mrh
          *ngIf="!isPolicyWaitingForSignature && policyDetails && isMrhBranch"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [hasLegalJr]="policyDetails.legalProtection"
          [isGdaAllowed]="isGdaAllowed"
          [productCode]="policyDetails.formulasAndOptionsInformations.formulaCode" />
      </div>
    </div>
  </div>
</div>
<app-generate-echeancier-dialog
  [visible]="generateEcheancierDialogVisible"
  (visibleChange)="generateEcheancierDialogVisibleChange($event)"
  (actionConfirmed)="generateEcheancier($event)"></app-generate-echeancier-dialog>
<app-message-service
  [id]="messageId"
  [severity]="severityMessage"
  [summaryMessage]="summaryMessage"
  [detailMessage]="detailMessage"></app-message-service>
